import { friendsQueryOptions } from '@/hooks/contacts/use-friends';
import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function messagesLayoutLoader() {
  return {
    promises: Promise.allSettled([
      queryClient.prefetchQuery(friendsQueryOptions),
      queryClient.prefetchQuery(groupsQueryOptions),
      queryClient.ensureQueryData(allChatSessionQueryOptions),
    ]).catch(catchFetcherError),
  };
}
